import { RouterModule, Routes } from '@angular/router';
import {LoginComponent} from "./login/login.component";
import { SignupComponent } from "./signup/signup.component";
import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {AuthGuard} from "./service/auth/auth.guard";
import {LogoutComponent} from "./logout/logout.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardLayoutComponent } from "./dashboard/dashboard-layout.component";
import {QuestionPoolComponent} from "./question-pool/question-pool.component";
import {QuestionPoolStudyComponent} from "./question-pool-study/question-pool-study.component";
import {QuestionPoolExamComponent} from "./question-pool-exam/question-pool-exam.component";
import {QuestionPoolResultsComponent} from "./question-pool-results/question-pool-results.component";
import {SavedTestsComponent} from "./saved-tests/saved-tests.component";
import {StudyTogetherComponent} from "./study-together/study-together.component";
import {SharedTestsComponent} from "./shared-tests/shared-tests.component";
import {SearchQuestionComponent} from "./search-question/search-question.component";
import {SubscriptionsComponent} from "./subscriptions/subscriptions.component";
import {MyProfileComponent} from "./my-profile/my-profile.component";
import {SettingsComponent} from "./settings/settings.component";
import {QuestionFlagsComponent} from "./question-flags/question-flags.component";
import {MyCommentsComponent} from "./my-comments/my-comments.component";
import {MyNotesComponent} from "./my-notes/my-notes.component";
import {MessengerComponent} from "./messenger/messenger.component";
import {AdminDashboardComponent} from "./admin/admin-dashboard.component";
import {AdminUsersComponent} from "./admin/admin-users.component";
import {AdminQuestionCommentsComponent} from "./admin/admin-question-comments.component";
import {AdminSettingsComponent} from "./admin/admin-settings.component";
import {AdminCoursesComponent} from "./admin/admin-courses.component";
import {AdminSubjectsComponent} from "./admin/admin-subjects.component";
import {AdminTopicsComponent} from "./admin/admin-topics.component";
import {AdminAreasComponent} from "./admin/admin-areas.component";
import {AdminQuestionsComponent} from "./admin/admin-questions.component";
import {AdminContentComponent} from "./admin/admin-content.component";
import {AdminLayoutComponent} from "./admin/admin-layout.component";
import {AdminMessagesComponent} from "./admin/admin-messages.component";
import {AdminNewsComponent} from "./admin/admin-news.component";
import {AdminSocialAnalyticsComponent} from "./admin/admin-social-analytics.component";
import {AdminSocialTemplatesComponent} from "./admin/admin-social-templates.component";
import {AdminAntifraudComponent} from "./admin/admin-antifraud.component";
import {AdminGuard} from "./service/auth/admin.guard";
import {NonAdminGuard} from "./service/auth/non-admin.guard";
import {CanDeactivateTestGuard} from "./service/auth/can-deactivate-test.guard";
import { LegalPageComponent } from './legal/legal-page.component';
import { PolicyAcceptanceComponent } from './legal/policy-acceptance.component';
import { GuestGuard } from './service/auth/guest.guard';
export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [GuestGuard] },
  { path: 'signup', component: SignupComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  { path: 'accept-terms', component: PolicyAcceptanceComponent, canActivate: [AuthGuard] },
  { path: 'privacy', component: LegalPageComponent, data: { legalPage: 'privacy' } },
  { path: 'terms', component: LegalPageComponent, data: { legalPage: 'terms' } },
  { path: 'account-deletion', component: LegalPageComponent, data: { legalPage: 'account-deletion' } },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'logout', component: LogoutComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard, NonAdminGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'subscriptions', component: SubscriptionsComponent },
      { path: 'my-profile', component: MyProfileComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'question-flags', component: QuestionFlagsComponent },
      { path: 'my-comments', component: MyCommentsComponent },
      { path: 'my-notes', component: MyNotesComponent },
      { path: 'messages', component: MessengerComponent },
    ]
  },
  { path: 'question-pool', component: QuestionPoolComponent, canActivate: [AuthGuard] },
  // { path: 'question-pool-study', component: QuestionPoolStudyComponent, canActivate: [AuthGuard]},
  { path: 'question-pool-study/:questionId/:init?', component: QuestionPoolStudyComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateTestGuard]},
  { path: 'question-pool-study/:questionId', component: QuestionPoolStudyComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateTestGuard]},
  // { path: 'question-pool-study-init/:questionId', component: QuestionPoolStudyComponent, canActivate: [AuthGuard],  runGuardsAndResolvers: 'always',},
  // { path: 'question-pool-exam', component: QuestionPoolExamComponent, canActivate: [AuthGuard]},
  { path: 'question-pool-exam/:questionId/:init?', component: QuestionPoolExamComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateTestGuard]},
  { path: 'question-pool-exam/:questionId', component: QuestionPoolExamComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateTestGuard]},
  // { path: 'question-pool-exam-init/:questionId', component: QuestionPoolExamComponent, canActivate: [AuthGuard],  runGuardsAndResolvers: 'always',},
  {
    path: 'question-pool-results/:reportId',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard, NonAdminGuard],
    children: [
      { path: '', component: QuestionPoolResultsComponent },
    ],
  },
  // Main Functions — /new-test redirects to the canonical /question-pool
  // configurator. The old /new-test stub component has been removed.
  { path: 'new-test', redirectTo: 'question-pool', pathMatch: 'full' },
  { path: 'saved-tests', component: SavedTestsComponent, canActivate: [AuthGuard] },
  { path: 'study-together', component: StudyTogetherComponent, canActivate: [AuthGuard] },
  { path: 'shared-tests', redirectTo: 'study-together', pathMatch: 'full' },
  { path: 'search-question', component: SearchQuestionComponent, canActivate: [AuthGuard] },
  // Legacy /report URL: redirect to dashboard instead of showing a dedicated page
  { path: 'report', redirectTo: 'dashboard', pathMatch: 'full' },
  // My Area - redirects to dashboard children for consistent layout
  { path: 'subscriptions', redirectTo: 'dashboard/subscriptions', pathMatch: 'full' },
  { path: 'my-profile', redirectTo: 'dashboard/my-profile', pathMatch: 'full' },
  { path: 'settings', redirectTo: 'dashboard/settings', pathMatch: 'full' },
  { path: 'question-flags', redirectTo: 'dashboard/question-flags', pathMatch: 'full' },
  { path: 'my-comments', redirectTo: 'dashboard/my-comments', pathMatch: 'full' },
  { path: 'my-notes', redirectTo: 'dashboard/my-notes', pathMatch: 'full' },
  { path: 'messages', redirectTo: 'dashboard/messages', pathMatch: 'full' },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard, AdminGuard],
    children: [
      { path: '', component: AdminDashboardComponent },
      { path: 'users', component: AdminUsersComponent },
      { path: 'fraud', component: AdminAntifraudComponent },
      { path: 'messages', component: AdminMessagesComponent },
      { path: 'question-comments', component: AdminQuestionCommentsComponent },
      { path: 'content', component: AdminContentComponent },
      { path: 'subscriptions', loadComponent: () => import('./admin/admin-subscriptions.component').then(m => m.AdminSubscriptionsComponent) },
      { path: 'settings', component: AdminSettingsComponent },
      { path: 'news', component: AdminNewsComponent },
      { path: 'social/analytics', component: AdminSocialAnalyticsComponent },
      { path: 'social/templates', component: AdminSocialTemplatesComponent },
    ]
  },
  { path: 'admin/courses', redirectTo: 'admin/content', pathMatch: 'full' },
  { path: 'admin/subjects', redirectTo: 'admin/content', pathMatch: 'full' },
  { path: 'admin/topics', redirectTo: 'admin/content', pathMatch: 'full' },
  { path: 'admin/areas', redirectTo: 'admin/content', pathMatch: 'full' },
  { path: 'admin/questions', redirectTo: 'admin/content', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },  // Wildcard route for a 404 page


];

export const AppRoutingModule = RouterModule.forRoot(routes, {
  // Optionally pass `routeReuseStrategy` here if not setting globally
});